import type { SequenceState, TransientSequenceError } from '../state';

export const setTransientSequenceError = (
  state: SequenceState,
  payload: TransientSequenceError | null
): SequenceState => {
  return {
    ...state,
    transientSequenceError: payload,
  };
};
